// extracted by mini-css-extract-plugin
module.exports = {"candidateSurveyRequestPage":"styles-module__candidateSurveyRequestPage___QQHlj","referencesCard":"styles-module__referencesCard___1i08B"};